// extracted by mini-css-extract-plugin
module.exports = {"competition-item":"_1DSFdX2IcNwk2DM6Xf3E","team-collapse":"_1YP4kcsqmECUJnjnBGFQ"};